import { FC } from "react";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import {
  ATTENDANCE_STATUS_LABELS,
  AttendanceStatusDistributionItem,
} from "src/apis/dashboardAttendance";
import ChartCard from "./ChartCard";
import { STATUS_COLORS } from "./constants";

type AttendanceStatusDonutProps = {
  data: AttendanceStatusDistributionItem[];
};

const AttendanceStatusDonut: FC<AttendanceStatusDonutProps> = ({
  data,
}): JSX.Element => {
  const chartData = data
    .filter((item) => item.total > 0)
    .map((item) => ({
      name: ATTENDANCE_STATUS_LABELS[item.status],
      value: item.total,
      status: item.status,
    }));

  return (
    <ChartCard title="Distribuição por status" isEmpty={chartData.length === 0}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            nameKey="name"
            innerRadius="55%"
            outerRadius="80%"
            paddingAngle={2}
          >
            {chartData.map((entry) => (
              <Cell key={entry.status} fill={STATUS_COLORS[entry.status]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default AttendanceStatusDonut;
